import { ActiveAntsPurchaseOrderService } from "src/services";
import { useFileDownload } from "../useFileDownload";

export const useActiveAntsPurchaseOrderFileDownload = (
  activeAntsPurchaseOrderService: ActiveAntsPurchaseOrderService
) => {
  const {
    mutate: download,
    isPending: isFileDownloading,
    error: fileLoadError,
    retry: retryDownload,
    reset: resetDownload
  } = useFileDownload<File>();

  const downloadFile = (activeAntsPurchaseOrderId: string) => {
    download({
      getFileData: () => activeAntsPurchaseOrderService.getActiveAntsPurchaseOrderPDF(activeAntsPurchaseOrderId)
    });
  };

  return {
    downloadFile,
    isFileDownloading,
    fileLoadError,
    retryDownload,
    resetDownload
  };
};
